import React from "react";
import { PrimaryLinkStyle as PrimaryLink } from "./BaseLink";

export const Link = (props) => {
	const { text } = props;

	return (
		<PrimaryLink {...props}>
			<span>{text}</span>
		</PrimaryLink>
	);
};
